import React from 'react';
import { Box, Typography, Card, CardContent, Button, Divider, CircularProgress } from '@mui/joy';
import { useNavigate } from 'react-router-dom';
import { useTickets } from '../../hooks/useSupport';
import { StatusChip, PriorityChip } from '../support/TicketStatusChip';
import { Ticket } from '@phosphor-icons/react';

export const RecentTicketsCard: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useTickets({ page_size: '3', ordering: '-created_at' });

  const tickets = data?.results || [];

  return (
    <Card variant="outlined" sx={{ height: '100%', backgroundColor: 'background.level1' }}>
      <CardContent>
        <Typography level="h3" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Ticket size={22} weight="duotone" /> Support Center
        </Typography>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
            <CircularProgress size="sm" />
          </Box>
        ) : tickets.length === 0 ? (
          <Typography level="body-md" sx={{ color: 'text.secondary', py: 2 }}>
            No support tickets yet.
          </Typography>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {tickets.map((ticket, index) => (
              <React.Fragment key={ticket.id}>
                {index > 0 && <Divider />}
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    py: 1,
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: 'background.level2' },
                    borderRadius: 'sm',
                    px: 1,
                  }}
                  onClick={() => navigate(`/manage/support`)}
                >
                  <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography level="body-sm" fontWeight="md" noWrap>
                      {ticket.ticket_number} - {ticket.subject}
                    </Typography>
                    <Typography level="body-xs" sx={{ color: 'text.tertiary' }}>
                      {new Date(ticket.created_at).toLocaleDateString()}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 0.5, ml: 1, flexShrink: 0 }}>
                    <StatusChip status={ticket.status} />
                    <PriorityChip priority={ticket.priority} />
                  </Box>
                </Box>
              </React.Fragment>
            ))}
          </Box>
        )}
        <Box sx={{ mt: 2 }}>
          <Button
            variant="solid"
            color="primary"
            size="sm"
            onClick={() => navigate('/manage/support')}
          >
            View All Tickets
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
